/**
 * 学习乐园 · 连连看题材包：事件配人物（lianliankan/pack-renwu.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：历史事件连主人公（「垓下之战」连「项羽」）。note 存一句
 * 来龙去脉——配上的那一瞬把「谁、干了什么、结果如何」讲一遍，事件、
 * 人物、故事三者挂钩（消除与配错反馈双向展示）。
 * 与既有两包分工：shijian 考「事件→朝代」的时间归属，dianxing 考
 * 「成语典故→主人公」——本包考「重大史事→当事人」，选题避开成语典故
 * 型事件（那边已收），专收史事名不含主人公名字的条目：牌面把答案
 * 写在脸上（如「郑成功收复台湾」）等于送分，配对失去意义。
 * 口径自检：26 条事件名互不重复、主人公互不重复——同人物出现两次
 * 会造成两张同名牌分属不同对，配错反馈就没法指对搭档（rel 型按
 * pair 报 mate，同 face 两张牌玩家无法区分）。
 * 26 对池（6×6 盘每局随机抽 18 上桌），按时间排序，多玩几局凑齐
 * 整条人物线。引擎抽样（buildDeck 先洗池再截 18），内容每局换。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.renwu = {
    id: 'renwu',
    name: '事件配人物',
    hint: '垓下之战连项羽，一条人物线',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: '桂陵之战', r: '孙膑', note: '围魏救赵，齐军军师' },
      { l: '修建都江堰', r: '李冰', note: '秦蜀郡守，父子主持修堰' },
      { l: '焚书坑儒', r: '秦始皇', note: '焚烧诗书、坑杀方士的暴政' },
      { l: '大泽乡起义', r: '陈胜', note: '「王侯将相宁有种乎」，首举义旗' },
      { l: '垓下之战', r: '项羽', note: '四面楚歌，霸王别姬' },
      { l: '写《史记》', r: '司马迁', note: '究天人之际，通古今之变' },
      { l: '改良造纸术', r: '蔡伦', note: '用树皮麻头破布造纸' },
      { l: '发明地动仪', r: '张衡', note: '候风地动仪测报地震方位' },
      { l: '发明麻沸散', r: '华佗', note: '世界最早的麻醉剂' },
      { l: '黄巾起义', r: '张角', note: '「苍天已死，黄天当立」' },
      { l: '官渡之战', r: '曹操', note: '以少胜多大败袁绍，奠定北方' },
      { l: '算圆周率到七位', r: '祖冲之', note: '3.1415926 到 3.1415927 之间' },
      { l: '修建赵州桥', r: '李春', note: '一千四百年不倒的石拱桥' },
      { l: '玄武门之变', r: '李世民', note: '先发制人，后开创贞观之治' },
      { l: '安史之乱', r: '安禄山', note: '起兵叛乱，唐由盛转衰' },
      { l: '陈桥兵变', r: '赵匡胤', note: '黄袍加身，建立北宋' },
      { l: '澶渊之盟', r: '寇准', note: '力请真宗亲征，促成宋辽议和' },
      { l: '发明活字印刷', r: '毕昇', note: '胶泥刻字，一版拆了还能再排' },
      { l: '编《资治通鉴》', r: '司马光', note: '砸缸的那个，后来写了编年史' },
      { l: '北京保卫战', r: '于谦', note: '土木堡之变后力守北京城' },
      { l: '编《本草纲目》', r: '李时珍', note: '二十七年走遍山野修药典' },
      { l: '虎门销烟', r: '林则徐', note: '1839 年公开销毁鸦片' },
      { l: '金田起义', r: '洪秀全', note: '广西金田村起事，建号太平天国' },
      { l: '收复新疆', r: '左宗棠', note: '率军西征，驱逐阿古柏势力' },
      { l: '戊戌变法', r: '康有为', note: '与梁启超推动百日维新' },
      { l: '辛亥革命', r: '孙中山', note: '推翻两千多年帝制，建立民国' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
